export enum ArticleDetailRoutesPath {
  THE_DANGERS_OF_MILEAGE_FRAUD = 'the-dangers-of-mileage-fraud',
  PRACTICAL_GUIDE_TO_SUCCESSFULLY_SELL_YOUR_USED_CAR = 'practical-guide-to-successfully-sell-your-used-car',
  ESSENTIAL_STEPS_TO_TAKE_BEFORE_BUYING_A_USED_CAR = 'essential-steps-to-take-before-buying-a-used-car',
  HOW_TO_PROPERLY_EVALUATE_YOUR_CAR_VALUE = 'how-to-properly-evaluate-your-car-value',
  THE_ADVANTAGES_OF_CHECKING_YOUR_CAR_HISTORY_BEFORE_PURCHASE = 'the-advantages-of-checking-your-car-history-before-purchase',
  WARNING_SIGNS_OF_A_POSSIBLE_MECHANICAL_ISSUE = 'warning-signs-of-a-possible-mechanical-issue',
}
